import React from 'react';
import { useSelector } from 'react-redux';
import { Globe, Location, Phone } from '@yme/assets/icons/destinations';
import { getPartnerDetailsPageState } from '@yme/components/Destinations/PartnerDetailsPage/redux/selectors';
import { OverviewComponent } from '@yme/components/Destinations/components';
import { BLANK } from '@yme/utils/constants';
export function Overview() {
    const { partnerPhone, partnerAddress, partnerWebsiteUrl } = useSelector(getPartnerDetailsPageState);
    const overviewData = [
        {
            text: partnerPhone && React.createElement("a", { href: `tel: +${partnerPhone}` },
                "+",
                partnerPhone),
            icon: Phone,
        },
        {
            text: partnerAddress,
            icon: Location,
        },
        {
            text: partnerWebsiteUrl && (React.createElement("a", { href: partnerWebsiteUrl, target: BLANK }, partnerWebsiteUrl)),
            icon: Globe,
        },
    ];
    return (React.createElement(OverviewComponent, { config: overviewData, isRoundIcon: true }));
}
